import * as S from './HeroImage.styled'

interface HeroImageProps {
  img: string
}

const HeroImage: React.FC<HeroImageProps> = ({ img }) => {
  return (
    <S.HeroImage>
      <img src={img} alt='' />
    </S.HeroImage>
  )
}

export default HeroImage
